import { __assign, __makeTemplateObject } from "tslib";
import * as React from 'react';
import ReactNotification, { store } from 'react-notifications-component';
import styled from 'styled-components';
import { animations } from '../../animations';
import { Alert } from '../Alert';
import styles from './defaultStyle';
var NOTIFICATION_WIDTH = 300;
var DEFAULT_NOTIFICATION_DURATION = 6000;
var DEFAULT_NOTIFICATION_CONTAINER = 'top-right';
var FullWidthContainer = styled(Alert)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n"], ["\n\twidth: 100%;\n"])));
var enterExitAnimation = {
    duration: 200,
    timingFunction: 'linear',
    delay: 0,
};
var generateNotificationId = function () {
    return Math.random().toString(36).substr(2, 9);
};
var getTransformedOptions = function (options) {
    var defaultOptions = {
        id: generateNotificationId(),
        duration: DEFAULT_NOTIFICATION_DURATION,
        container: DEFAULT_NOTIFICATION_CONTAINER,
    };
    if (typeof options === 'string' || React.isValidElement(options)) {
        return __assign({ content: options }, defaultOptions);
    }
    else {
        return __assign(__assign({}, defaultOptions), options);
    }
};
var NotificationContainer = function (_a) {
    var children = _a.children, type = _a.type, onDismiss = _a.onDismiss, id = _a.id;
    return (React.createElement(FullWidthContainer, { emphasized: Boolean(type), success: type === 'success', danger: type === 'danger', warning: type === 'warning', info: type === 'info', onDismiss: function () {
            if (onDismiss) {
                onDismiss();
            }
            store.removeNotification(id);
        } }, children));
};
export var NotificationsContainer = styled(ReactNotification)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\t", "\n\n\tposition: fixed;\n\tz-index: 9000;\n\tpointer-events: none;\n\twidth: 100%;\n\theight: 100%;\n\n\t/* This overrides the react-notification library's default container shadow */\n\t.notification-item {\n\t\tbox-shadow: none;\n\t}\n"], ["\n\t", "\n\t", "\n\n\tposition: fixed;\n\tz-index: 9000;\n\tpointer-events: none;\n\twidth: 100%;\n\theight: 100%;\n\n\t/* This overrides the react-notification library's default container shadow */\n\t.notification-item {\n\t\tbox-shadow: none;\n\t}\n"])), animations, styles);
export var notifications = {
    addNotification: function (options) {
        var transformedOptions = getTransformedOptions(options);
        store.addNotification({
            container: transformedOptions.container,
            animationIn: ['animated', 'fadeIn', 'faster'],
            animationOut: ['animated', 'fadeOut', 'faster'],
            slidingEnter: enterExitAnimation,
            slidingExit: enterExitAnimation,
            touchRevert: enterExitAnimation,
            touchSlidingExit: {
                swipe: enterExitAnimation,
                fade: enterExitAnimation,
            },
            dismiss: {
                duration: transformedOptions.duration,
                pauseOnHover: true,
                waitForAnimation: false,
                click: false,
                touch: false,
            },
            width: NOTIFICATION_WIDTH,
            id: transformedOptions.id,
            content: (React.createElement(NotificationContainer, { type: transformedOptions.type, onDismiss: transformedOptions.onDismiss, id: transformedOptions.id }, transformedOptions.content)),
        });
    },
    removeNotification: function (id) { return store.removeNotification(id); },
};
var templateObject_1, templateObject_2;
